import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Paper,
  Button,
  CircularProgress,
} from "@mui/material";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import { useSelector } from "react-redux";
import BulkVerificationTable from "./VendorVerificationTable";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const VendorVerificationPartial = () => {
  const loginData = useSelector((state) => state.loginData.value);
  const [user_token] = useState(loginData?.user?.token);
  const [org_token] = useState(loginData?.organization_token);

  const [documentType, setDocumentType] = useState("pan");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const [bulkresponse, setBulkResponse] = useState([]);
  const [responseloading, setResponseLoading] = useState(false);

  const fetch_all_bulk_verification = async () => {
    try {
      setResponseLoading(true);
      const res = await axios.post(API_ENDPOINT.fetch_all_bulk_verification);
      console.log(res);
      setBulkResponse(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setResponseLoading(false);
    }
  };

  const fetch_verificaton_logs = async () => {
    try {
      const res = await axios.post(API_ENDPOINT.fetch_verificaton_logs, {
        org_token: user_token,
      });
      console.log(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetch_all_bulk_verification();
    fetch_verificaton_logs();
  }, []);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) setFile(selected);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) setFile(droppedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleSubmit = async () => {
    if (!file || !documentType) {
      alert("Please select a document type and upload a file.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("document_type", documentType);
    formData.append("buyer_token", user_token);

    try {
      const res = await axios.post(
        API_ENDPOINT.bulk_document_verification,
        formData
      );
      fetch_all_bulk_verification();
      setResults(res.data.results || []);
    } catch (error) {
      alert("Verification failed");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSampleDownload = () => {
    const sampleDataMap = {
      pan: ["VendorMail", "PAN Number", "VendorCode"],
      gst: ["VendorMail", "GSTNUMBER", "VendorCode"],
      bank: ["VendorMail", "Bank_Account", "IFSC", "VendorCode"],
      msme: ["VendorMail", "Udyam", "VendorCode"],
      mca: ["VendorMail", "CIN", "VendorCode"],
    };

    const selectedHeaders = sampleDataMap[documentType];

    if (!selectedHeaders) {
      alert("Please select a document type first.");
      return;
    }

    const csvContent = selectedHeaders.join(",") + "\n"; // Add one empty row
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `sample_${documentType}_template.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ margin: "1rem" }}>
      <HeaderTitle titleText="Advance Onboarding" />
      <Box sx={{ p: 2 }}>
        {/* Radio Buttons */}
        <FormControl component="fieldset" sx={{ mb: 3 }}>
          <FormLabel
            component="legend"
            sx={{ fontSize: "14px", fontWeight: "bold" }}
          >
            Select the Verification Type
          </FormLabel>
          <RadioGroup
            row
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
            sx={{ fontSize: "12px" }}
          >
            <FormControlLabel
              value="pan"
              control={<Radio />}
              label={<Typography sx={{ fontSize: "14px" }}>PAN</Typography>}
            />
            <FormControlLabel
              value="gst"
              control={<Radio />}
              label={<Typography sx={{ fontSize: "14px" }}>GST</Typography>}
            />
            <FormControlLabel
              value="bank"
              control={<Radio />}
              label={<Typography sx={{ fontSize: "14px" }}>Bank</Typography>}
            />
            <FormControlLabel
              value="msme"
              control={<Radio />}
              label={<Typography sx={{ fontSize: "14px" }}>MSME</Typography>}
            />
            <FormControlLabel
              value="cin"
              control={<Radio />}
              label={<Typography sx={{ fontSize: "14px" }}>CIN</Typography>}
            />
          </RadioGroup>
        </FormControl>

        {/* Drag & Drop File Upload */}
          {/* Drag & Drop */}
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              textAlign: "center",
              border: "2px dashed #aaa",
              cursor: "pointer",
              backgroundColor: "#f9f9f9",
              maxWidth: "350px",
              height: "150px",
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={() => fileInputRef.current.click()}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", 
                alignItems: "center", 
                height: "100%", 
                textAlign: "center",
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 500 }}>
                Drag and drop file here
              </Typography>
              <Typography variant="h6" color="textSecondary">
                (Supported format excel / csv)
              </Typography>
            </div>

            <input
              type="file"
              accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              hidden
              ref={fileInputRef}
              onChange={handleFileChange}
            />
          </Paper>
           {/* file name */}
          {file && (
            <div style={{ marginTop: "0.8rem" }}>
              <Button
                variant="outlined"
                size="large"
                onClick={() => setFile(null)}
                sx={{
                  textTransform: "none",
                  fontSize: "12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  // gap: "8px",
                  width: "100%",
                  maxWidth: "110px",
                  padding: "1px 10px",
                }}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                    flexGrow: 1,
                  }}
                  title={file.name}
                >
                  {file.name}
                </span>
                <DeleteForeverIcon fontSize="large" sx={{ color: "#FF0000" }} />
              </Button>
            </div>
          )}
      </Box>
       

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          marginLeft: "18px",
        }}
      >
        <Button
          variant="outlined"
          sx={{ mb: 2, fontSize: "10px" }}
          onClick={handleSampleDownload}
          disabled={!documentType}
        >
          Download Sample CSV
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          sx={{
            padding: "10px",
            fontSize: "10px",
          }}
        >
          {loading ? <CircularProgress size={24} /> : "Start Verification"}
        </Button>
      </div>

      <div>
        {/* {!responseloading && bulkresponse.results && ( */}
        <BulkVerificationTable data={bulkresponse} />
        {/* )} */}
      </div>
    </div>
  );
};

export default VendorVerificationPartial;
